import reviews from '../../../content/onBuild/reviews.json';
import upsolveJSONLD from './upsolveJSONLD';

const ratingsJSONLD = {
  ...upsolveJSONLD,
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "bestRating": "5",
    "reviewCount": reviews.length
  },
  "reviews": reviews.map(r => ({
    "@type" : "Review",
    "author" : {
      "@type" : "Person",
      "name" : r.reviewer
    },
    "datePublished" : r.date,
    "reviewRating" : {
      "@type" : "Rating",
      "ratingValue" : r.rating
    },
    "reviewBody" : ((r.review || {}).review || '').trim(),
  })),
}

export default ratingsJSONLD;